import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  createLink,
  getStatus,
} from 'src/app/components/profile/user-profile/view-profile/regular-user-profile/regular-user-profile-helper';
import { EntityStatus } from 'src/app/interfaces/views.interface';
import { UserBasic } from 'src/app/swagger-api';

@Component({
  selector: 'app-user-basic',
  templateUrl: './user-basic.component.html',
  styleUrls: ['./user-basic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserBasicComponent {
  @Input({ required: true }) public user: UserBasic;

  @Input({ required: false }) public srtIndex = 0;
  @Input({ required: false }) public hasTableSizeLimit = false;
  @Input({ required: false }) public hasConnectionSizeLimit = false;
  @Input({ required: false }) public redirectToLoginIfNoSession = false;
  @Input({ required: false }) public accessForAdmin = false;

  public get getStatus(): EntityStatus {
    return getStatus(this.user);
  }

  public get getLink(): string {
    return createLink(this.user.account_status, this.user.user_id, this.accessForAdmin);
  }
}
